import { PermissionNames } from "~/types/entityNames.ts";

// The backend refuses each quota route with a 403 for a user without one of these permissions.
// Every quota page, link and quota request in the frontend checks this same set.
export const QUOTA_ACCESS_PERMISSIONS = [PermissionNames.CanManageProjects, PermissionNames.CanManageInvoices];
